import React, {useEffect, useState} from 'react';
import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { isBrowser } from "react-device-detect";
import ListGroup from 'react-bootstrap/ListGroup';
import WarningNotiifcation from 'components/WarningNotification';
import Form from 'react-bootstrap/Form';
import { get } from 'services';

const mt15 = {
    marginTop: 5
}

const isBrowserMt = isBrowser ? mt15 : null;

const VehicleCard = ({data}) => {
    const [vehicle, setVehicle] = useState([]);
    const [category, setCategory] = useState([]);
    useEffect( () => {
        setVehicle(data);
        get("LicenciaConducirTipo").then(response => {
          setCategory(response.data)
        });
    }, [data])

    return (
     <> 
        {   
         vehicle.length > 0 ? 
         vehicle.map((element) => {
           return (
            <Card style={mt15}>
              <Card.Body className={'p-30'}>
              <Row>
                <Col xs={isBrowser ? 6 : 12 }>
                     <Row> 
                         <Col xs={isBrowser ? 3 : 12}>
                             <strong> Categoría </strong>
                         </Col>
                         <Col xs={isBrowser ? 9 : 12}>
                            {
                              element.licenciaConducirTipoId ?
                                category && category.length > 0 ? 
                                category.map((e, i) => {
                                  return (
                                    <span> {element.licenciaConducirTipoId == e.id ? e.descripcion : ""} </span>
                                  )
                                })
                                : ""
                              : "No especificado"
                            } 
                         </Col>
                         <Col style={mt15} xs={isBrowser ? 3 : 12}>
                             <strong> Año </strong>
                         </Col>
                         <Col style={isBrowserMt} xs={isBrowser ? 9 : 12}>
                             {
                               element.fabricadoEn ? element.fabricadoEn
                               : "No especificado"
                             }
                         </Col>
                       </Row>
                 </Col>
                 <Col xs={isBrowser ? 6 : 12 }>
                     <Row> 
                         <Col xs={isBrowser ? 3 : 12}>
                             <strong> Marca </strong>
                         </Col>
                         <Col xs={isBrowser ? 9 : 12}>
                             {element.marcaNombre}
                         </Col>
                         <Col style={mt15} xs={isBrowser ? 3 : 12}>
                             <strong> Modelo </strong>
                         </Col>
                         <Col style={isBrowserMt} xs={isBrowser ? 9 : 12}>
                             {element.modeloNombre}
                         </Col>
                       </Row>
                 </Col>
               </Row>
              </Card.Body>
            </Card>       
           )
         })
          :
        <Form.Group as={Col} md="12">
          <WarningNotiifcation message='No ha agregado ' enphasis='vehículos'/>
        </Form.Group>
      }
     </>
    );
};

export default VehicleCard;